var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityBubbleImage } from '../entities/entity-bubble-image';
import { Icon } from './icon';
import { classNames } from '@shapeable/utils';
import { useLink } from '../hooks/use-link';
import { ChevronDownIconGlyph, SubMenuIcon } from '@shapeable/icons';
import { useComponentPropsFor } from '../context/component-props-context';
import { MenuItemDefaultProps } from './menu-item';
var cls = classNames('navigation-menu-item');
export var NavigationMenuItemDefaultProps = {
  iconSize: 32,
  colors: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    font-size: 1em;\n    cursor: pointer;\n    user-select: none; /* Standard syntax */\n    ", "\n  \n    ", "\n    \n    \n    a {\n      color: inherit;\n      display: flex;\n      width: 100%;\n      box-sizing: border-box;\n      justify-content: flex-start;\n      align-items: center;\n      text-decoration: none;\n      padding: ", " ", ";\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    font-size: 1em;\n    cursor: pointer;\n    user-select: none; /* Standard syntax */\n    ", "\n  \n    ", "\n    \n    \n    a {\n      color: inherit;\n      display: flex;\n      width: 100%;\n      box-sizing: border-box;\n      justify-content: flex-start;\n      align-items: center;\n      text-decoration: none;\n      padding: ", " ", ";\n    }\n  "])), theme.APPLY_COLORS, function (_a) {
    var colors = _a.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.APPLY_COLORS({
      colors: colors,
      selector: cls.sub('label')
    }));
  }, theme.UNIT(2), theme.UNIT(4)),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    a {\n      width: 300px;\n    }\n  "], ["\n    a {\n      width: 300px;\n    }\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), theme.UNIT(3))
});
var LabelStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    text-transform: inherit;\n  "], ["\n    text-transform: inherit;\n  "])))
});
var BubbleStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), theme.UNIT(3))
});
var BodyStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    align-items: center;\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    align-items: center;\n    ", "\n  "])), function (_a) {
    var hasDisclosure = _a.hasDisclosure;
    return hasDisclosure && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      justify-content: space-between;\n    "], ["\n      justify-content: space-between;\n    "])));
  })
});
var DisclosureIconStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    transition: transform 0.2s ease-in-out;\n    ", "\n  "], ["\n    transition: transform 0.2s ease-in-out;\n    ", "\n  "])), function (_a) {
    var isDisclosed = _a.isDisclosed;
    return isDisclosed && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      transform: rotate(180deg);\n    "], ["\n      transform: rotate(180deg);\n    "])));
  })
});
// -------- Components -------->
var My = {
  NAME: 'NavigationMenuItem',
  Container: styled.li(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.span.attrs(cls.attr('label'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icon)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Bubble: styled(EntityBubbleImage)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BubbleStyles),
  Layout: styled.span(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  DisclosureIcon: styled(Icon)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), DisclosureIconStyles)
};
export var NavigationMenuItem = function (props) {
  // merge in menu item default props, to avoid havingto define the same colors twice  
  var defaultProps = useComponentPropsFor('MenuItem', MenuItemDefaultProps, NavigationMenuItemDefaultProps);
  var _a = useComponentPropsFor(My.NAME, defaultProps, props),
    className = _a.className,
    children = _a.children,
    colors = _a.colors,
    href = _a.href,
    icon = _a.icon,
    isActive = _a.isActive,
    label = _a.label,
    iconSize = _a.iconSize,
    entity = _a.entity,
    onClick = _a.onClick;
  var Link = useLink().Link;
  var hasChildren = entity.children && entity.children.length > 0;
  var childIsActive = hasChildren && entity.children.find(function (child) {
    return child.isActive;
  });
  var onClickProp = !childIsActive ? onClick : null;
  return React.createElement(My.Container, {
    colors: colors,
    onClick: onClickProp,
    isActive: isActive,
    className: cls.name(className)
  }, React.createElement(Link, {
    href: href
  }, React.createElement(My.Layout, {
    hasDisclosure: hasChildren
  }, React.createElement(My.Body, null, icon ? React.createElement(My.Icon, {
    size: iconSize
  }, icon) : entity.page ? React.createElement(My.Bubble, {
    entity: entity.page,
    size: 32
  }) : React.createElement(My.Icon, {
    size: iconSize + 2
  }, React.createElement(SubMenuIcon, null)), React.createElement(My.Label, null, label || children)), hasChildren && !childIsActive && React.createElement(My.DisclosureIcon, {
    size: 16,
    isDisclosed: entity.isDisclosed
  }, React.createElement(ChevronDownIconGlyph, null)))), children);
};
NavigationMenuItem.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;